/**
 * @generated SignedSource<<3bd6bbcbf48213abaf2cc5e17276dfbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RecurringRequestExclusionReason = "AGENDA_UNAVAILABLE" | "REQUEST_NOT_AVAILABLE";
export type RequestRecurrenceEndCondition = "AFTER_OCCURRENCES" | "ON_DATE";
export type RequestRecurrenceType = "DAY" | "MONTH" | "WEEK";
export type UpsertPatronRequestSeriesInput = {
  recurrence: PatronRequestRecurrenceInput;
  reviewedPlanToken: string;
  sourceBookingId: string;
};
export type PatronRequestRecurrenceInput = {
  endCondition: RequestRecurrenceEndCondition;
  endDate?: string | null | undefined;
  occurrenceCount?: number | null | undefined;
  recurrenceType: RequestRecurrenceType;
  repeatInterval: number;
};
export type useUpsertPatronRequestSeriesMutation$variables = {
  input: UpsertPatronRequestSeriesInput;
};
export type useUpsertPatronRequestSeriesMutation$data = {
  readonly responsePayload: {
    readonly bookingSeries: {
      readonly bookings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly startSlot: {
              readonly agenda: {
                readonly date: string;
              };
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly effectiveEndDate: string | null | undefined;
      readonly endCondition: RequestRecurrenceEndCondition | null | undefined;
      readonly id: string;
      readonly recurrenceType: RequestRecurrenceType | null | undefined;
      readonly repeatInterval: number | null | undefined;
      readonly requestedOccurrenceCount: number | null | undefined;
    } | null | undefined;
    readonly createdOccurrenceCount: number | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly excluded: ReadonlyArray<{
      readonly date: string;
      readonly reason: RecurringRequestExclusionReason;
    }> | null | undefined;
    readonly removedOccurrenceCount: number | null | undefined;
    readonly success: boolean;
    readonly updatedOccurrenceCount: number | null | undefined;
  } | null | undefined;
};
export type useUpsertPatronRequestSeriesMutation = {
  response: useUpsertPatronRequestSeriesMutation$data;
  variables: useUpsertPatronRequestSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOccurrenceCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedOccurrenceCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedOccurrenceCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestExclusion",
  "kind": "LinkedField",
  "name": "excluded",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repeatInterval",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCondition",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestedOccurrenceCount",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 366
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      {
        "direction": "DESC",
        "field": "DATE_TIME"
      }
    ]
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpsertPatronRequestSeriesMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpsertPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "upsertPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BookingSeries",
            "kind": "LinkedField",
            "name": "bookingSeries",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "BookingConnection",
                "kind": "LinkedField",
                "name": "bookings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "startSlot",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agenda",
                                "kind": "LinkedField",
                                "name": "agenda",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpsertPatronRequestSeriesMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpsertPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "upsertPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BookingSeries",
            "kind": "LinkedField",
            "name": "bookingSeries",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "BookingConnection",
                "kind": "LinkedField",
                "name": "bookings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "startSlot",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agenda",
                                "kind": "LinkedField",
                                "name": "agenda",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8428a6b9759b4c52aff5a235ab8feef",
    "id": null,
    "metadata": {},
    "name": "useUpsertPatronRequestSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation useUpsertPatronRequestSeriesMutation(\n  $input: UpsertPatronRequestSeriesInput!\n) {\n  responsePayload: upsertPatronRequestSeries(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    createdOccurrenceCount\n    updatedOccurrenceCount\n    removedOccurrenceCount\n    excluded {\n      date\n      reason\n    }\n    bookingSeries {\n      id\n      recurrenceType\n      repeatInterval\n      endCondition\n      effectiveEndDate\n      requestedOccurrenceCount\n      bookings(first: 366, orderBy: [{field: DATE_TIME, direction: DESC}]) {\n        edges {\n          node {\n            __typename\n            id\n            startSlot {\n              __typename\n              agenda {\n                date\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0c09e0690935a8377f5dc03d1f9c32e";

export default node;
